module.exports = __webpack_public_path__ + "img/mm-icon.f833847e.svg";